import { InteractionType } from '@precon-tools-suite-by-shared/vue-msal';
import type { PreconUserProfilesGlobalOptions } from '@precon-tools-suite-by-shared/shared-auth-ui';

/**
 * Put all the options for this library that must be set in the `main.ts` of the application here.
 */
export interface PreconAuthenticationGlobalOptions
    extends PreconUserProfilesGlobalOptions {
    defaultScopes?: readonly string[];
    defaultInteractionType?: InteractionType;
    popupPostLogoutRedirectUri?: string;
    overwriteTeamIsEditorTeam?: boolean;
}

/**
 * This is the type of the options object used within the library.
 */
export type NormalizedPreconAuthenticationGlobalOptions = {
    defaultScopes: readonly string[];
    defaultInteractionType: InteractionType;
    popupPostLogoutRedirectUri: string;
    overwriteTeamIsEditorTeam: boolean | null;
};

/**
 * Function to convert the input options (`PreconAuthenticationGlobalOptions`) to the normalized
 * options (`NormalizedPreconAuthenticationGlobalOptions`).
 *
 * It usually just sets the default values for the library.
 *
 * @param options The input options as set in the application that uses this library.
 */
export function normalizePreconAuthenticationOptions(
    options: PreconAuthenticationGlobalOptions = {}
): NormalizedPreconAuthenticationGlobalOptions {
    return {
        defaultScopes: [
            'openid',
            ...(options?.defaultScopes ?? []),
        ] as readonly string[],
        defaultInteractionType:
            options.defaultInteractionType ?? InteractionType.Redirect,
        popupPostLogoutRedirectUri:
            options.popupPostLogoutRedirectUri ?? '/blank.html',
        overwriteTeamIsEditorTeam: options.overwriteTeamIsEditorTeam ?? null,
    };
}
